

// --------------------------------------------------------------------------------

interface uploadWithProgressProps {
    url: string
    method?: 'POST' | 'PATCH' | 'PUT'
    data: XMLHttpRequestBodyInit
    container: HTMLLabelElement | null
    span: HTMLSpanElement | null
}

export const uploadWithProgress = async ({ url, method = 'POST', data, container, span }: uploadWithProgressProps) => {
    const xhr = new XMLHttpRequest()
    return new Promise((resolve, reject) => {

        // xhr.upload.addEventListener('loadstart', e => {
        //     if (e.lengthComputable) {
        //         console.log('start upload')
        //     }
        // })

        // upload
        xhr.upload.addEventListener("progress", e => {
            if (e.lengthComputable && container && span) {
                const progress = +(e.loaded / e.total * 100).toFixed()
                container.style.backgroundPosition = `${100 - progress}%`
                container.style.transitionDuration = '0.14s'
                span.innerHTML = Math.round(e.loaded / 1024).toLocaleString('ru') + ' KB / ' + Math.round(e.total / 1024).toLocaleString('ru')

                if (e.loaded / e.total === 1) {
                    // console.log(`upload has been completed`)
                }
            }
        })

        // download
        // xhr.addEventListener("progress", e => {
        //     if (e.lengthComputable) {
        //         console.log('start download')
        //     }
        // })

        xhr.addEventListener("loadend", () => {
            // console.log(`download has been completed`)
            if (container && span) {
                container.removeAttribute('style')
                span.innerHTML = ''
            }
        })

        xhr.addEventListener('error', e => reject(e))

        xhr.open(method, url, true)
        // xhr.setRequestHeader("Content-Type", "application/octet-stream")
        xhr.responseType = 'json'
        xhr.onreadystatechange = (e) => {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                const status = xhr.status
                if (status === 0 || (status >= 200 && status < 400)) {
                    resolve(xhr.response)
                } else {
                    reject(xhr.response)
                }
            }
        }
        xhr.send(data)
    })
}